import { FilterList } from "@mui/icons-material";
import { DatePicker, DateTimePicker } from "@mui/lab";
import {
  Badge,
  Button,
  Card,
  CardContent,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  Modal,
  Paper,
  Select,
  TextField,
  Tooltip,
  Autocomplete,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import moment from "moment-timezone";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%", // Adjust width for mobile
  maxWidth: "500px", // Keep a max-width for larger screens
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  borderRadius: "10px",
};

function ProductionReporFilter({
  entryType,
  setEntryType,
  plates,
  setSelectedPlate,
  selectedPlate,
  createdBy,
  setCreatedBy,
  searchJob,
  setSearchJob,
  apUsers,
  onFilter,
  createdDateFrom,
  setCreatedDateFrom,
  createdDateTo,
  setCreatedDateTo,
}) {
  const resetFilters = () => {
    setCreatedBy("");
    setCreatedDateFrom("");
    setCreatedDateTo("");
    setSelectedPlate("");
    setSearchJob(null);
  };
  const [count, setCount] = useState(0);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  useEffect(() => {
    let totalCount = 0;
    if (entryType) totalCount++;
    if (createdBy) totalCount++;
    if (createdDateFrom) totalCount++;
    if (createdDateTo) totalCount++;
    if (selectedPlate) totalCount++;
    if (searchJob) totalCount++;
    setCount(totalCount);
  }, [entryType, createdBy, createdDateFrom, createdDateTo, selectedPlate, searchJob]);

  return (
    <Paper>
      <Tooltip title="Filters">
        <Badge badgeContent={count} color="error">
          <IconButton onClick={handleOpen} aria-label="Filters" size="small">
            <FilterList />
          </IconButton>
        </Badge>
      </Tooltip>
      {apUsers && (
        <Modal open={open} onClose={handleClose}>
          <Card sx={style}>
            <CardContent>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Autocomplete
                    options={apUsers}
                    getOptionLabel={(option) => option.name}
                    filterOptions={(options, { inputValue }) => {
                      if (!inputValue) return options;
                      const searchTerm = inputValue.toLowerCase();
                      return options.filter((option) =>
                        option.name.toLowerCase().includes(searchTerm)
                      );
                    }}
                    value={apUsers.find((user) => user._id === createdBy) || null}
                    onChange={(event, newValue) => setCreatedBy(newValue?._id || "")}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Created By"
                        placeholder="Search users..."
                        variant="outlined"
                      />
                    )}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12}>
                  <Autocomplete
                    options={plates}
                    getOptionLabel={(option) =>
                      `${option.height}x${option.width}x${option.thickness} || ${option?.brand?.name} || ${option?.technology?.name}`
                    }
                    filterOptions={(options, { inputValue }) => {
                      if (!inputValue) return options;
                      const searchTerm = inputValue.toLowerCase();
                      return options.filter((option) =>
                        `${option.height}x${option.width}x${option.thickness} || ${option?.brand} || ${option?.technology?.name}`
                          .toLowerCase()
                          .includes(searchTerm)
                      );
                    }}
                    value={plates.find((plate) => plate._id === selectedPlate) || null}
                    onChange={(event, newValue) => setSelectedPlate(newValue?._id || "")}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Plate"
                        placeholder="Search plates..."
                        variant="outlined"
                      />
                    )}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    type="text"
                    fullWidth
                    name="Search"
                    value={searchJob}
                    id="search-field"
                    label="Search (basis of jobid /job name)"
                    onChange={(e) => setSearchJob(e.target.value)}
                  />
                </Grid>
                <Grid item xs={6}>
                  <DateTimePicker
                    name="created_date_from"
                    label="DPR Created From"
                    value={createdDateFrom ? moment(createdDateFrom).utcOffset('+05:30') : null}
                    onChange={(newValue) => {
                      const utcDate = newValue ? moment(newValue).utcOffset('+05:30').utc().toISOString() : '';
                      setCreatedDateFrom(utcDate);
                    }}
                    inputFormat="dd/MM/yyyy HH:mm"
                    renderInput={(props) => <TextField {...props} fullWidth />}
                  />

                </Grid>
                <Grid item xs={6}>
                  <DateTimePicker
                    name="created_date_to"
                    label="DPR Created To"
                    value={createdDateTo ? moment(createdDateTo).utcOffset('+05:30') : null}
                    onChange={(newValue) => {
                      const utcDate = newValue ? moment(newValue).utcOffset('+05:30').utc().toISOString() : '';
                      setCreatedDateTo(utcDate);
                    }}
                    inputFormat="dd/MM/yyyy HH:mm"
                    renderInput={(props) => <TextField {...props} fullWidth />}
                  />

                </Grid>
                <Grid item xs={6}>
                  <Button onClick={resetFilters} color="error" fullWidth>
                    Reset All Filters
                  </Button>
                </Grid>
                <Grid item xs={6}>
                  <Button
                    onClick={() => {
                      handleClose();
                      onFilter();
                    }}
                    color="success"
                    fullWidth
                  >
                    OK
                  </Button>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Modal>
      )}
    </Paper>
  );
}

export default ProductionReporFilter;
